import { Box, Typography } from '@mui/material';
import { useLogic } from './logic';

type Props = {
  mainMessage?: string;
  subMessage?: string;
};

export function EmptyBox({ mainMessage, subMessage }: Props) {
  const { isMobile } = useLogic();

  return (
    <Box
      sx={{
        paddingY: isMobile ? 5 : 10,
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
      }}
    >
      {Boolean(mainMessage) && (
        <Typography
          variant={
            isMobile ? 'JP/Heading/m/Medium/Tight' : 'JP/Heading/lg/Bold/Tight'
          }
          component="p"
          color="#595960"
        >
          {mainMessage}
        </Typography>
      )}
      {Boolean(subMessage) && (
        <Typography
          variant="JP/Body/m/Regular/Normal"
          color="#595960"
          component="p"
        >
          {subMessage}
        </Typography>
      )}
    </Box>
  );
}
